// extracted by mini-css-extract-plugin
export default {"slider-container":"styles_slider-container__ON-OH","temperature-title":"styles_temperature-title__h55dQ","temperature-label":"styles_temperature-label__cmOaT"};